import { GameClient } from '../../gameClient/gameClient';
import { CurrentUser } from '../../general/modules/user/currentUser';
import { ConsentStateCommand } from '../../gameClient/clientCommands/consentStateCommand';

type GetConsentStateParams = {
    suid: string
}

export class GetConsentStateHandler {
    public handle(_params: GetConsentStateParams): void {
        CurrentUser.getInstance()
            .getConsentState()
            .then((consent)=>{
                GameClient.getInstance().sendCommand(new ConsentStateCommand({
                    consent
                }));
            });
    }
}

